import {
    Container,
    Header,
    Aside,
    Main,
    Menu,
    Submenu,
    MenuItem,
    MenuItemGroup,
    Breadcrumb,
    BreadcrumbItem,
    Row,
    Col,
    DatePicker,
    TimePicker,
    Input,
    Button,
    Table,
    TableColumn,
    Pagination,
    InputNumber,
    Checkbox,
    CheckboxGroup,
    RadioButton,
    RadioGroup,
    Loading,
    Select,
    Option,
    Cascader,
    Radio,
    Switch,
    Tabs,
    TabPane,
    Collapse,
    CollapseItem,
    Form,
    FormItem,
    Popover,
    Card,
    Transfer,
    Upload,
    MessageBox,
    Message,
    Dialog,
    Slider,
    Tooltip,
    Tag
} from 'element-ui'

const el = [
    Container,
    Header,
    Aside,
    Main,
    Menu,
    Submenu,
    MenuItem,
    MenuItemGroup,
    Breadcrumb,
    BreadcrumbItem,
    Row,
    Col,
    DatePicker,
    TimePicker,
    Input,
    Button,
    Table,
    TableColumn,
    Pagination,
    InputNumber,
    Checkbox,
    CheckboxGroup,
    RadioButton,
    RadioGroup,
    Loading,
    Select,
    Option,
    Cascader,
    Radio,
    Switch,
    Tabs,
    TabPane,
    Collapse,
    CollapseItem,
    Form,
    FormItem,
    Popover,
    Card,
    Transfer,
    Upload,
    Dialog,
    Slider,
    Tooltip,
    Tag
];

const $elm = {
    $message: Message,
    $alert: MessageBox.alert,
    $confirm: MessageBox.confirm,
    $prompt: MessageBox.prompt,
};

export {
    el,
    $elm
}
